export default {
	"0": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Mensaje del servidor"
		}
	},
	"1": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Se ha producido un error inesperado."
		}
	},
	"2": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Se ha perdido la sesión.",
			"to" : 'logout'
		}
	},
	"3": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Usuario no válido."
		}
	},
	"4": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "La oferta que buscas no está disponible.",
			"to" : "ofertas"
		}
	},
	"5": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Ya estás inscrito a esta oferta."
		}
	},
	"6": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Esta es una oferta de empleo, tu perfil es de usuario de prácticas contacta con administración."
		}
	},
	"7": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Esta es una oferta de prácticas, tu perfil es de usuario de empleo contacta con administración."
		}
	},
	"8": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Ya existe el dato que quieres dar de alta. Bórralo de tu perfil antes de volver a adjuntarlo."
		}
	},
	"10": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Ya estás inscrito a esta oferta."
		}
	},
	"11": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Documentación Pendiente",
			"cuerpo" : "Esta oferta tiene documentos obligatorios que no tienes subidos en tu perfil. Por favor revisa los documentos requeridos y actualiza tu ficha de CV para poder inscribirte en la oferta. "
		}
	},
	"12": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "El archivo que intentas subir es demasiado grande, recuerda que su tamaño no puede exceder de 1Mb."
		}
	},
	"15": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Debes rellenar todos los datos."
		}
	},
	"17": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "No se puede inscribir en la oferta porque se solapa con sus prácticas."
		}
	},
	"18": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "La oferta a la que intentas inscribirte es para estudiantes de grado."
		}
	},
	"19": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "La oferta a la que intentas inscribirte es para estudiantes de post grado."
		}
	},
	"21": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Se ha producido un error inesperado.UTP"
		}
	},
	"22": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Se ha producido un error inesperado.UTE"
		}
	},
	"25": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Alguno de los grados de discapacidad es mayor del 100%."
		}
	},
	"26": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Alguno de los grados de discapacidad introducido es inferior al 33% por lo que no se considera oficialmente discapacidad." 
		}
	},
	"30": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "La candidatura ya ha sido tramitada, no puedes desinscribirte." 
		}
	},
	"31": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "No se encuentra la candidatura"
		}
	},
	"32": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Este usuario no puede registrarse a más ofertas"
		}
	},
	"34": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "El permiso de trabajo es obligatorio para usuarios con nacionalidad distinta a los 28 países de la Unión Europea.<br>Marca en tu perfil la casilla de que tienes permiso de trabajo antes de modificar cualquier dato o realizar ninguna gestión.",
			"to" : "mi-cv"
		}
	},
	"37": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "El campo Mínima retribución aceptada es obligatorio. Complétalo para poder continuar"
		}
	},
	"38": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Para poder editar la información de tu perfil es necesario subir un documento de tu CV personal en el área Mi CV > Documentación. Las empresas consultan primero ese CV personal y es necesario para poder presentar tu candidatura correctamente. Por favor, añade un CV"
		}
	},
	"500": {
		"categoria" : "medium",
		"es" :{
			"titulo" : "Error",
			"cuerpo" : "Para poder poder utilizar la plataforma debes aceptar la RGPD"
		}
	}
}



// WEBPACK FOOTER //
// ./src/errors/index.js